import { Accessibility as AccessibilityIcon, CategoryTE as MobileIcon } from '@magalu/stereo-ui-icons';
import { arrayOf, object, shape, string } from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { Container, Content, Link, LinkImage, LinkItem, Links, OpeningHours, Phone, SalesChannels, SaleChannel, SectionTitle, SocialLinks } from './ContactSection.styled';
import { Link as LinkComponent } from '../../../../atoms';

const ContactSection = ({
  phone,
  salesChannels,
  openingHours,
  accessibility,
  mobileVersion,
  links,
  social
}) => {
  const renderSocial = () => {
    if (!(social != null && social.links)) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionTitle, null, social.title || 'Siga para mais conteúdo:'), /*#__PURE__*/React.createElement(SocialLinks, null, social.links.map(({
      url,
      img,
      label
    }, socialIndex) => /*#__PURE__*/React.createElement(LinkItem, {
      key: socialIndex
    }, /*#__PURE__*/React.createElement(LinkComponent, {
      href: url,
      target: "_blank",
      title: label
    }, /*#__PURE__*/React.createElement(LinkImage, {
      src: img,
      alt: label
    }))))));
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Content, null, phone && /*#__PURE__*/React.createElement(Phone, null, phone), /*#__PURE__*/React.createElement(SalesChannels, {
    "data-testid": "sales-channels"
  }, salesChannels == null ? void 0 : salesChannels.map(saleChannel => /*#__PURE__*/React.createElement(SaleChannel, {
    key: _.uniqueId('salesChannelsContactSection')
  }, saleChannel.icon, /*#__PURE__*/React.createElement("span", null, saleChannel.label)))), /*#__PURE__*/React.createElement(OpeningHours, null, openingHours), /*#__PURE__*/React.createElement(Links, null, links == null ? void 0 : links.map((link, linkIndex) => /*#__PURE__*/React.createElement(LinkItem, {
    key: linkIndex
  }, /*#__PURE__*/React.createElement(Link, {
    href: link.url,
    title: link.title,
    p: 0
  }, link.label))), accessibility && /*#__PURE__*/React.createElement(LinkItem, null, /*#__PURE__*/React.createElement(AccessibilityIcon, {
    color: "currentColor"
  }), /*#__PURE__*/React.createElement(Link, {
    href: accessibility.url,
    title: accessibility.title
  }, accessibility.label)), mobileVersion && /*#__PURE__*/React.createElement(LinkItem, null, /*#__PURE__*/React.createElement(MobileIcon, {
    color: "currentColor"
  }), /*#__PURE__*/React.createElement(Link, {
    href: mobileVersion.url,
    title: mobileVersion.title
  }, mobileVersion.label))), renderSocial()));
};

process.env.NODE_ENV !== "production" ? ContactSection.propTypes = {
  phone: string,
  salesChannels: arrayOf(shape({
    label: string,
    icon: object
  })),
  openingHours: string,
  links: arrayOf(shape({})),
  accessibility: shape({
    url: string,
    title: string,
    label: string
  }),
  mobileVersion: shape({
    url: string,
    title: string,
    label: string
  }),
  social: shape({
    title: string,
    links: arrayOf(shape({
      url: string,
      img: string
    }))
  })
} : void 0;
export default ContactSection;